import con from '../../../connection';
import { ApiGetCompanyDetailResponse } from './api-get-company-detail.response';

const path = '/companies';
const companies = (url: string) => () => ({
  get: () => con.get<ApiGetCompanyDetailResponse>(url + path, {}),
});

export default companies;
